import { render, staticRenderFns } from "./BreadcrumbComponent.vue?vue&type=template&id=2b32a4da&scoped=true"
import script from "./BreadcrumbComponent.js?vue&type=script&lang=js&external"
export * from "./BreadcrumbComponent.js?vue&type=script&lang=js&external"
import style0 from "./BreadcrumbComponent.vue?vue&type=style&index=0&id=2b32a4da&prod&scoped=true&lang=css"
import style1 from "./BreadcrumbComponent.vue?vue&type=style&index=1&id=2b32a4da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b32a4da",
  null
  
)

export default component.exports